import React, { Component } from "react";
import { Link } from "react-router-dom";
import fingerprintBanner from "../../Assets/images/fingerprint-banner.jpg";
import GlobalLoader from "../globalLoader";
import Slider from "react-slick";
import axios from "axios";
import ReactModal from "react-modal";
import { Scrollbars } from "react-custom-scrollbars";
import MetaTags from "../metaTags"


import Flintgroup from "../../Assets/images/partners/flintgroup.png"
import Asahi from "../../Assets/images/partners/asahi.png"
import Esko from "../../Assets/images/partners/esko.png"
// import Hamillroad from "../../Assets/images/partners/hamillroad.jpg"
import Macdermid from "../../Assets/images/partners/macdermid.png"
const apiUrl = process.env.REACT_APP_API;

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showProductModal: false,
      productList: [],
      fingerprintProductList: [],
      testimonialList: [],
      productBannerList: [],
      _isProductBannerList: false,
      _isProductList: false,
      _isTestimonialList: false
    };
    this.showProjectModal = this.showProjectModal.bind(this);
    this.hideProjectModal = this.hideProjectModal.bind(this);
    this.handleBanners = this.handleBanners.bind(this);
  }
  showProjectModal() {
    this.setState({
      showProductModal: true
    });
  }
  hideProjectModal() {
    this.setState(
      {
        showProductModal: false
      },
      () => {
        // let projectPopup = document.getElementsByClassName("new-project");
        // if (projectPopup[0].classList.contains("product-list")) {
        //   projectPopup[0].classList.remove("product-list");
        // }
      }
    );
  }
  getProductList = async () => {
    // console.log("asd");
    let current = this;
    let loader = document.getElementById("loader");
    loader.classList.add("show");

    let requestUrl = `/products/getList/Fingerprint`;
    // let currentComponent = this;
    let res = await axios.get(apiUrl + requestUrl);

    let { data } = res;
    if (data.error === null) {
      current.setState(
        {
          fingerprintProductList: data.payload
        },
        () => {
          if (loader.classList.contains("show")) {
            loader.classList.remove("show");
          }
          current.showProjectModal();
        }
      );
    }
  };
  componentDidMount() {
    document.body.classList.add("home");
    this.handleBanners();
    this.handleTestimonials();
    this.handleProducts();
  }
  componentWillUnmount() {
    document.body.classList.remove("home");
    this._isProductBannerList = false;
    this._isProductList = false;
    this._isTestimonialList = false;
  }

  handleProducts = async () => {
    const requsetUrl = "/homepagecategories";
    let currentComponent = this;
    let res = await axios.get(apiUrl + requsetUrl);
    let { data } = res;
    // console.log(data);
    if (data.error === null) {
      let productList = data.payload;
      currentComponent.setState({
        productList,
        _isProductList: true
      });
    }
  };

  handleTestimonials = async () => {
    const requsetUrl = "/testimonials";
    let currentComponent = this;
    let res = await axios.get(apiUrl + requsetUrl);
    let { data } = res;
    if (data.error === null) {
      let testimonialList = data.payload;
      currentComponent.setState({
        testimonialList,
        _isTestimonialList: true
      });
    }
  };

  handleBanners = async () => {
    const requsetUrl = "/banners";
    var currentComponent = this;
    let res = await axios.get(apiUrl + requsetUrl);
    let { data } = res;
    if (data.error === null) {
      let productBannerList = data.payload;
      currentComponent.setState({
        productBannerList,
        _isProductBannerList: true
      });
    }
  };

  render() {
    const {
      _isProductBannerList,
      _isProductList,
      _isTestimonialList,
      productList,
      testimonialList,
      productBannerList,
      fingerprintProductList,
      showProductModal
    } = this.state;

    let isHomePageReady = false;
    if (
      _isProductBannerList === true &&
      _isProductList === true &&
      _isTestimonialList === true
    ) {
      isHomePageReady = true;
    }
    return (
      <React.Fragment>
        <MetaTags/>
        <GlobalLoader loaderState={isHomePageReady} />
        <div id="loader" className="loader fixed circle">
          <svg
            width="200px"
            height="200px"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid"
            className="lds-rolling"
          >
            <circle
              cx="50"
              cy="50"
              fill="none"
              ng-attr-stroke="{{config.color}}"
              ng-attr-stroke-width="{{config.width}}"
              ng-attr-r="{{config.radius}}"
              ng-attr-stroke-dasharray="{{config.dasharray}}"
              stroke="#B8BE14"
              strokeWidth="2"
              r="30"
              strokeDasharray="141.37166941154067 49.12388980384689"
              transform="rotate(159.346 50 50)"
            >
              <animateTransform
                attributeName="transform"
                type="rotate"
                calcMode="linear"
                values="0 50 50;360 50 50"
                keyTimes="0;1"
                dur="1.4s"
                begin="0s"
                repeatCount="indefinite"
              ></animateTransform>
            </circle>
          </svg>
        </div>
        
        <ReactModal
          isOpen={showProductModal}
          onRequestClose={this.hideProjectModal}
          ariaHideApp={false}
          shouldCloseOnOverlayClick={true}
          portalClassName="modal product-list new-project"
        >
          <React.Fragment>
            <div className="title">Select Product</div>
            <Scrollbars
              className="scroll-bar-continer"
              autoHeight
              autoHeightMin={100}
              autoHeightMax={400}

            >
             <div className="product-list">
                {fingerprintProductList.map((list, key) => {
                  return (
                    <div className="item" key={key}>
                    <Link to={`/products/` + list.url}>
                      <img src={list.thumbnail} alt={list.name}/>
                      <div className="text-box">
                        <div className="table">
                          <div className="cell">
                            <div className="title">{list.name}</div>
                            {/* <div className="description">
                              {list.short_description}
                            </div> */}
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                  );
                })}
              </div>
            </Scrollbars>
          </React.Fragment>
        </ReactModal>
        <div className="home-container">
          <section className="slider">
            <Slider
              lazyLoad={true}
              dots={true}
              arrows={false}
              infinite={true}
              slidesToShow={1}
              slidesToScroll={1}
              autoplay={true}
              autoplaySpeed={4000}
              pauseOnHover={true}
              customPaging={function(i) {
                return <button></button>;
              }}
            >
              {productBannerList.map((list, key) => {
                return (
                  <div className="item" key={key}>
                    <div className="image-box">
                      <img alt="" src={list.image} />
                    </div>
                    <div className="text-box">
                      <div className="table">
                        <div className="cell">
                          <div className="title">{list.title}</div>
                          <div className="description">{list.description}</div>
                          {list.url && list.url !== '' ? 
                            (
                              <Link to={list.url}>{list.buttonText}</Link>
                            ) : (
                              ''
                            )
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </Slider>
          </section>

          <section className="products">
            <div className="wrapper">
              <h2 className="section-title">Product Categories</h2>
              <div className="product-list ">
                {productList.map((list, key) => {
                    return (
                      <div className="item" key={key}>
                        <Link to={`/category/` + list.key}>
                          <img src={list.thumbnail} alt={list.name}/>
                          <div className="text-box">
                            <div className="table">
                              <div className="cell">
                                <div className="title">{list.name}</div>
                                <div className="description">
                                   {list.products.length > 0 ? 

                                      list.products.map((item , key) => {
                                        return (
                                          <span key={key}>
                                            {item.name}
                                            {list.products.length !== key+1 ? ', ':''}
                                          </span>
                                        )
                                      })
                                    :('')
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    );
                  })}
              </div>
            </div>
          </section>

          <section className="production-info">
            <div className="wrapper">
              <div className="item">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 86.52 86.52">
                  <g>
                    <rect className="cls-1" width="86.52" height="86.52"/>
                    <path className="cls-2" d="M75.82,43.13A32.47,32.47,0,0,0,43.43,10.7h0A32.6,32.6,0,0,0,10.7,43.13,32.09,32.09,0,0,0,13.29,55.8,33.29,33.29,0,0,0,30.72,73.23a32.1,32.1,0,0,0,12.6,2.59h.08A32.59,32.59,0,0,0,75.82,43.13Zm-8.88,18a29.61,29.61,0,0,1-17,11.11l-1.78.41,1.33-1.26a38,38,0,0,0,7.9-10.78l.14-.28h10Zm5.94-16a30,30,0,0,1-3.43,12.11l-.14.27H58.78l.25-.67A39.78,39.78,0,0,0,61.38,45l0-.48H72.92ZM69.53,29.33a29.21,29.21,0,0,1,3.35,11.83l0,.53H61.39l0-.47A39.35,39.35,0,0,0,59,29.74l-.25-.67H69.39Zm-19.6-15A29.62,29.62,0,0,1,67,25.39l.6.8H57.53l-.14-.27a37.93,37.93,0,0,0-7.91-10.77L48.16,13.9Zm-5.1.63.82.68a35.37,35.37,0,0,1,8.21,9.84l.43.74H44.83Zm0,14.14H55.66l.12.31a35.79,35.79,0,0,1,2.7,11.78l0,.53H44.83Zm0,15.47H58.52l0,.53a36.37,36.37,0,0,1-2.72,12.07l-.12.31H44.83Zm0,15.76h9.46l-.43.74a35.61,35.61,0,0,1-8.21,9.87l-.82.68ZM19.55,25.39A30,30,0,0,1,36.86,14.28l1.77-.39-1.31,1.25a37.79,37.79,0,0,0-7.94,10.78l-.13.27H18.94ZM13.64,41.16A29.21,29.21,0,0,1,17,29.31l.15-.27H28l-.25.67a39.41,39.41,0,0,0-2.33,11.51l0,.47H13.6Zm3.46,16A29.46,29.46,0,0,1,13.64,45.1l0-.53H25.38l0,.47a39.78,39.78,0,0,0,2.35,11.74l.25.67H17.24Zm19.75,15a30,30,0,0,1-17.22-11.1L19,60.32H29.25l.13.28a38,38,0,0,0,7.93,10.78l1.31,1.24ZM28.26,44.57H42V57.45H31.12L31,57.14a36.12,36.12,0,0,1-2.72-12ZM42,71.59l-.82-.68a35.37,35.37,0,0,1-8.21-9.84l-.43-.75H42Zm0-29.9H28.27l0-.53A35.85,35.85,0,0,1,31,29.38l.12-.31H42Zm0-15.5H32.49l.43-.74a35.37,35.37,0,0,1,8.21-9.84l.82-.69Z"/>
                  </g>
                </svg>
                <div className="title">Worldwide Quality</div>
                <div className="description">
                  To guarantee optimal performance, we use our unique NDXC workflow developed by NDIGITEC 30 year’s expertise to make sure the production process, the quality of images and plates correspond to the highest world standards.
                </div>
              </div>
              <div className="item">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 86.52 86.52"
                >
                  <rect className="cls-1" width="86.52" height="86.52" />
                  <path
                    className="cls-2"
                    d="M67.27,40.24C70,37.22,71,36.58,71,34.52c0-1.65,0-1.59-3.71-5.78a1.27,1.27,0,0,1-.37-1c0-.31.95-4.45.95-5a4.2,4.2,0,0,0-2.91-4l-3.71-1.21a1.29,1.29,0,0,1-1-.9V16.6l-1.22-3.76a4.26,4.26,0,0,0-4-2.92c-.69,0-4.67,1-5,1-1.64,0-3.13-4.13-6.73-4.13s-5,4.13-6.73,4.13c0,0-4.61-1-5-1a4.21,4.21,0,0,0-4,2.92L26.3,16.6v-.05a1.32,1.32,0,0,1-1,1h.06l-3.77,1.22a4.18,4.18,0,0,0-2.91,4c0,.64,1,4.82,1,5a1.27,1.27,0,0,1-.38.95c-2.6,3-3.76,3.55-3.76,5.78s1,2.75,3.76,5.72a1.4,1.4,0,0,1,.38,1l-.06.26L18.67,46v.26a4.34,4.34,0,0,0,2.91,4l2.81.9L16.28,73.42l10.34-1.54,6.84,7.84,6.78-18.55a4.87,4.87,0,0,0,3,1.06,4.76,4.76,0,0,0,3-1.11l6.79,18.6L60,71.88l10.28,1.54L62.13,51.21l2.81-.9a4.34,4.34,0,0,0,2.91-4c0-.58-.1-.63,0-.53l-.95-4.24v-.26A1.39,1.39,0,0,1,67.27,40.24Zm-2-1.86a4.53,4.53,0,0,0-1.11,2.87,2.29,2.29,0,0,0,.1.9v-.06l.8,3.77a1.51,1.51,0,0,0,0,.42,1.43,1.43,0,0,1-1,1.38l-3.76,1.22a4.27,4.27,0,0,0-2.7,2.7l-1.22,3.76a1.44,1.44,0,0,1-1.38,1,1.21,1.21,0,0,0-.42-.05A30.41,30.41,0,0,0,50,55.4c-3.71,0-5,4.08-6.73,4.08s-3-4.08-6.73-4.08c-1,0-4.45,1-5,1a1.31,1.31,0,0,1-1.33-1L29,51.53a4.36,4.36,0,0,0-2.81-2.65h.06l-3.77-1.22a1.45,1.45,0,0,1-1-1.38l.06-.26.95-4.51v-.26a4.48,4.48,0,0,0-1.11-2.86c-3.08-3.4-3-3.24-3-3.87s-.32-.11,3.07-3.93a4.42,4.42,0,0,0,1.06-2.8c0-.64-1-4.83-1-5a1.31,1.31,0,0,1,1-1.32l3.76-1.22.06-.06A4.59,4.59,0,0,0,29,17.5v-.05l1.22-3.76a1.31,1.31,0,0,1,1.32-1c.11,0,4.72,1,5,1,3.5,0,5-4.14,6.73-4.14s3.18,4.14,6.73,4.14c.8,0,4.77-1,5-1a1.37,1.37,0,0,1,1.38,1l1.22,3.76V17.4a4.27,4.27,0,0,0,2.65,2.75l3.82,1.28a1.29,1.29,0,0,1,1,1.32c0,.16-1,4.29-1,5a4.26,4.26,0,0,0,1.12,2.8c3,3.29,3,3.24,3,3.93S68.28,35.05,65.26,38.38Zm-22-16.53a12.67,12.67,0,1,0,0,25.33h0A12.66,12.66,0,0,0,55.93,34.52h0A12.67,12.67,0,0,0,43.26,21.85Zm0,22.58a9.92,9.92,0,1,1,9.91-9.91,9.93,9.93,0,0,1-9.91,9.91Zm-10.76,30-4.82-5.52L20.42,70l6.09-16.8,1,3a4.21,4.21,0,0,0,4,2.91c1,0,4.51-1,5-1a2.35,2.35,0,0,1,1.59.9Zm26.4-5.52L54,74.43,48.4,59.05a2.52,2.52,0,0,1,1.59-.9c.21,0,.48.06,4.45.9,0,0,.06.06.59.06a4.33,4.33,0,0,0,4-2.92l1-2.91L66.11,70Z"
                  />
                </svg>
                <div className="title">Always as new</div>
                <div className="description">
                  We always make sure to use our latest production technologies in order to provide you with remarkably maximum durable plates which will serve you a longest available lifetime in the market and will always seem like a new one.
                </div>
              </div>
              <div className="item">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 86.52 86.52">
                    <g>
                        <rect className="cls-1" width="86.52" height="86.52"/>
                        <path className="cls-2" d="M43.29,45.18A26.45,26.45,0,0,1,68,62.42l2.91-.85a29.64,29.64,0,0,0-9.85-13.42,29,29,0,0,0-6.88-3.91l-2.75-1.1,2.24-1.94a16.41,16.41,0,1,0-21.21.17l2.27,1.9L32,44.41A29.46,29.46,0,0,0,15.62,61.74l2.91.83A26.44,26.44,0,0,1,43.29,45.18ZM29.57,28.77A13.39,13.39,0,1,1,43,42.16,13.41,13.41,0,0,1,29.57,28.77ZM23.77,67.9l1,2.06,2.28.33L25.42,71.9l.39,2.27-2-1.08-2,1.08.39-2.27-1.64-1.61L22.75,70Zm9.75,0,1,2.06,2.28.33L35.17,71.9l.39,2.27-2-1.08-2,1.08.39-2.27-1.65-1.61L32.5,70Zm9.75,0,1,2.06,2.28.33L44.92,71.9l.39,2.27-2-1.08-2,1.08.39-2.27L40,70.29,42.25,70Zm9.75,0L54,70l2.27.33L54.67,71.9l.39,2.27-2-1.08-2,1.08.39-2.27-1.65-1.61L52,70Zm9.75,0,1,2.06,2.27.33L64.41,71.9l.39,2.27-2-1.08-2,1.08.39-2.27-1.65-1.61L61.75,70Z"/>
                    </g>
                </svg>
                <div className="title">Customer Satisfaction</div>
                <div className="description">
                  Making our customers happy is of utmost importance to us. We offer a 30 days return policy as a guarantee and provide such service that will be fully based on our customers’ needs and requirements.
                </div>
              </div>
            </div>
          </section>

          <section className="process">
            <div className="wrapper">
              <h2 className="section-title">Process</h2>
              <div className="wrap-box">
                <div className="top">
                  <div className="item">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                      <g>
                        <rect className="cls-1" width="100" height="100"/>
                        <path className="cls-2" d="M62.89,34.13,51.25,20.83a1.65,1.65,0,0,0-2.34-.15,1.14,1.14,0,0,0-.16.15L37.12,34.13a1.65,1.65,0,0,0,.15,2.34,1.68,1.68,0,0,0,1.1.42H45v21.6a1.66,1.66,0,0,0,1.66,1.66h6.65A1.66,1.66,0,0,0,55,58.49V36.89h6.65a1.67,1.67,0,0,0,1.25-2.76Zm6.18,23.18v11H30.93v-11H24V72.05a3.57,3.57,0,0,0,3.46,3.68H72.53A3.58,3.58,0,0,0,76,72.05h0V57.31Z"/>
                      </g>
                    </svg>
                  </div>

                  <div className="item">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                      <g>
                        <rect className="cls-1" width="100" height="100"/>
                        <path className="cls-2" d="M74.4,44.05l-4.3-.55a22,22,0,0,0-1.29-3.14L71.46,37a3.4,3.4,0,0,0-.28-4.52l-3.6-3.59a3.39,3.39,0,0,0-4.53-.29L59.64,31.2a21,21,0,0,0-3.14-1.3L56,25.61a3.42,3.42,0,0,0-3.39-3H47.44a3.42,3.42,0,0,0-3.39,3L43.5,29.9a21.42,21.42,0,0,0-3.14,1.3L37,28.55a3.4,3.4,0,0,0-4.52.28l-3.59,3.59A3.39,3.39,0,0,0,28.55,37l2.65,3.42a20.86,20.86,0,0,0-1.3,3.13l-4.29.55a3.42,3.42,0,0,0-3,3.39v5.12a3.42,3.42,0,0,0,3,3.39l4.29.54a21,21,0,0,0,1.3,3.14l-2.65,3.42a3.4,3.4,0,0,0,.28,4.52l3.59,3.59a3.41,3.41,0,0,0,4.54.29l3.41-2.65a21,21,0,0,0,3.14,1.3l.54,4.28a3.42,3.42,0,0,0,3.39,3h5.12a3.41,3.41,0,0,0,3.39-3l.55-4.29a21,21,0,0,0,3.14-1.3l3.41,2.65a3.39,3.39,0,0,0,4.52-.27l3.6-3.6a3.4,3.4,0,0,0,.28-4.53L68.8,59.64a21,21,0,0,0,1.3-3.14L74.39,56a3.42,3.42,0,0,0,3-3.39V47.44A3.41,3.41,0,0,0,74.4,44.05ZM50,61.42A11.42,11.42,0,1,1,61.42,50,11.41,11.41,0,0,1,50,61.42Z"/>
                      </g>
                    </svg>
                  </div>

                  <div className="item">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                      <g>
                        <rect className="cls-1" width="100" height="100"/>
                        <path className="cls-2" d="M69.39,37.87,57,36.32a29.7,29.7,0,0,0,2.24-11.38c0-2.77-.88-4.81-2.64-6.06a7.57,7.57,0,0,0-4.49-1.27h-.18c-3,.33-3.86,3.1-3.74,4.91A5.11,5.11,0,0,1,48,23.89a24.76,24.76,0,0,1-2.2,4.92l-.06.12a7.31,7.31,0,0,1-3.31,3.21,16.73,16.73,0,0,0-4,3.16,18.47,18.47,0,0,0-2.1,2.91,2.34,2.34,0,0,0-.32.56l0,.06a2,2,0,0,0-.12.22c-.07.12-.15.26-.22.41-1.27,1.1-3.24,1.08-4.43,1.07H30.9a5.35,5.35,0,0,0-4,1.51A5.45,5.45,0,0,0,25.48,46V63.42a5.1,5.1,0,0,0,1.42,4,5.9,5.9,0,0,0,4,1.2h3.82a7.66,7.66,0,0,1,3,.91c.64.29,1.38.61,2.21.91,3.94,1.36,9.18,2,16.5,2h5.81a6.19,6.19,0,0,0,4.32-1.8,4.07,4.07,0,0,0,1.21-2.39,9,9,0,0,0,.07-.93,4.7,4.7,0,0,0-.27-1.77A5.84,5.84,0,0,0,71,63.93a5.73,5.73,0,0,0,1.74-4.2,5.39,5.39,0,0,0-1.08-3.26,4.76,4.76,0,0,0,1.16-.81,5.6,5.6,0,0,0-.08-7.5,6.39,6.39,0,0,0,1.83-4.25A5.65,5.65,0,0,0,69.39,37.87Z"/>
                      </g>
                    </svg>
                  </div>

                  <div className="item">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                      <g>
                        <rect className="cls-1" width="100" height="100"/>
                        <path className="cls-2" d="M50,42.1A7.9,7.9,0,1,0,57.9,50h0A7.91,7.91,0,0,0,50,42.1Zm0-12.22A31.73,31.73,0,0,0,20.5,50a31.69,31.69,0,0,0,59,0A31.72,31.72,0,0,0,50,29.88ZM50,63.4A13.41,13.41,0,1,1,63.41,50h0A13.41,13.41,0,0,1,50,63.4Z"/>
                      </g>
                    </svg>
                  </div>

                  <div className="item">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                      <g>
                        <rect className="cls-1" width="100" height="100"/>
                        <path className="cls-2" d="M79.88,31.37l-4.62-4.55a2.09,2.09,0,0,0-3,0L43.54,55.56,31.63,43.65A2.07,2.07,0,0,0,30.15,43h0a2.14,2.14,0,0,0-1.48.62l-4.55,4.59a2.1,2.1,0,0,0,0,3l17.94,18a2.08,2.08,0,0,0,1.49.62h0A2.07,2.07,0,0,0,45,69.17L79.89,34.34a2.13,2.13,0,0,0,.61-1.49A2.06,2.06,0,0,0,79.88,31.37Z"/>
                      </g>
                    </svg>
                  </div>
                </div>
                <div className="bottom">
                  <div className="item">
                    <div className="title">Upload</div>
                    <div className="description">
                      Upload your file in the form.
                    </div>
                  </div>
                  <div className="item">
                    <div className="title">Adjust</div>
                    <div className="description">
                      Modify its properties and characteristics.
                    </div>
                  </div>
                  <div className="item">
                    <div className="title">Approve</div>
                    <div className="description">
                      Confirm the final design of the plate. 
                    </div>
                  </div>
                  <div className="item">
                    <div className="title">Supervise</div>
                    <div className="description">
                      Monitor the status of your printing plate production
                    </div>
                  </div>

                  <div className="item">
                    <div className="title">Receive</div>
                    <div className="description">
                      Use our plates to produce your unique prints.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="partners">
              <div className="wrapper-small">
                <h2 className="section-title">Partners</h2>

                <div className="logo-box">
                  <div className="image-box"><img alt="" src={Flintgroup}/></div>
                  <div className="image-box"><img alt="" src={Asahi}/></div>
                  <div className="image-box"><img alt="" src={Esko}/></div>
                  <div className="image-box"><img alt="" src={Macdermid}/></div>
                </div>
              </div>
          </section>
         
          <section className="bottom">
            <div className="image-box">
              <img alt="" src={fingerprintBanner} />
            </div>
            <div className="text-box">
              <div className="table">
                <div className="cell">
                  <div className="title">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24.097"
                      height="29.256"
                      viewBox="0 0 24.097 29.256"
                    >
                      <path
                        d="M8.142-34.385a.612.612,0,0,1-.276-.069,16.94,16.94,0,0,0-3.749-1.472A17.546,17.546,0,0,0,0-36.432a17.546,17.546,0,0,0-4.117.506,16.51,16.51,0,0,0-3.749,1.472.579.579,0,0,1-.8-.253.582.582,0,0,1,.23-.805,16.8,16.8,0,0,1,4.025-1.564A17.736,17.736,0,0,1,0-37.628a17.736,17.736,0,0,1,4.416.552,17.18,17.18,0,0,1,4.025,1.564.6.6,0,0,1,.23.805A.611.611,0,0,1,8.142-34.385Zm3.312,7.5a.611.611,0,0,1-.506-.253A13.09,13.09,0,0,0,6.3-31.4a13.657,13.657,0,0,0-3.013-1.173A13.154,13.154,0,0,0,0-32.982a13.335,13.335,0,0,0-3.312.414A13.928,13.928,0,0,0-6.3-31.4a13.09,13.09,0,0,0-4.646,4.255.644.644,0,0,1-.851.161.644.644,0,0,1-.161-.851A14.406,14.406,0,0,1,0-34.178,14.365,14.365,0,0,1,11.937-27.83a.621.621,0,0,1-.161.851A.528.528,0,0,1,11.454-26.887ZM4.094-8.372a.672.672,0,0,1-.207-.046,11.462,11.462,0,0,1-3.2-1.771,11.683,11.683,0,0,1-2.507-2.6A11.881,11.881,0,0,1-4.048-19.78,4.054,4.054,0,0,1,0-23.828,4.054,4.054,0,0,1,4.048-19.78,2.851,2.851,0,0,0,6.9-16.928,2.866,2.866,0,0,0,9.752-19.78a9.722,9.722,0,0,0-.759-3.8A9.858,9.858,0,0,0,6.9-26.68,10.125,10.125,0,0,0,3.8-28.773,9.722,9.722,0,0,0,0-29.532a9.722,9.722,0,0,0-3.8.759A9.858,9.858,0,0,0-6.9-26.68a9.858,9.858,0,0,0-2.093,3.1,9.722,9.722,0,0,0-.759,3.8,20.352,20.352,0,0,0,.943,6.118.587.587,0,0,1-.391.736.593.593,0,0,1-.759-.391,21.076,21.076,0,0,1-.989-6.463,10.732,10.732,0,0,1,.851-4.255,11.259,11.259,0,0,1,2.346-3.5,11.258,11.258,0,0,1,3.5-2.346A11.15,11.15,0,0,1,0-30.728a11.237,11.237,0,0,1,4.255.851,10.9,10.9,0,0,1,3.473,2.346,10.874,10.874,0,0,1,2.346,3.5,10.753,10.753,0,0,1,.874,4.255A4.054,4.054,0,0,1,6.9-15.732,4.054,4.054,0,0,1,2.852-19.78,2.866,2.866,0,0,0,0-22.632,2.851,2.851,0,0,0-2.852-19.78a10.806,10.806,0,0,0,2,6.3A11.489,11.489,0,0,0,1.4-11.132,11.386,11.386,0,0,0,4.278-9.545a.589.589,0,0,1,.368.759A.609.609,0,0,1,4.094-8.372Zm-7.176-.391a.613.613,0,0,1-.46-.207,16.858,16.858,0,0,1-2.9-4.968A16.226,16.226,0,0,1-7.5-19.78a7.539,7.539,0,0,1,2.185-5.313A7.539,7.539,0,0,1,0-27.278a7.446,7.446,0,0,1,5.29,2.185A7.465,7.465,0,0,1,7.5-19.78a.609.609,0,0,1-.6.6.594.594,0,0,1-.6-.6,6.359,6.359,0,0,0-1.84-4.462A6.359,6.359,0,0,0,0-26.082a6.359,6.359,0,0,0-4.462,1.84A6.262,6.262,0,0,0-6.3-19.78a15.517,15.517,0,0,0,.966,5.428,15.765,15.765,0,0,0,2.714,4.6.614.614,0,0,1-.069.851A.625.625,0,0,1-3.082-8.763ZM7.36-11.822a7.962,7.962,0,0,1-3.1-.621,8.591,8.591,0,0,1-2.53-1.7,7.789,7.789,0,0,1-1.7-2.53A7.962,7.962,0,0,1-.6-19.78a.594.594,0,0,1,.6-.6.609.609,0,0,1,.6.6A6.677,6.677,0,0,0,2.576-15,6.732,6.732,0,0,0,7.36-13.018a.609.609,0,0,1,.6.6A.609.609,0,0,1,7.36-11.822Z"
                        transform="translate(12.057 37.628)"
                        fill="#B8BE14"
                      />
                    </svg>
                    Fingerprint
                  </div>
                  <div className="description">
                    The printing flow of every company is unique. Request a fingerprint so that we can create perfect plates, customized specifically to produce flawless prints.  
                  </div>
                  <div className="button" onClick={this.getProductList}>
                    Try now
                  </div>
                </div>
              </div>
            </div>
          </section>
        
          

          <section className="testimonials">
            <div className="wrapper-small">
              <h2 className="section-title">Testimonials</h2>
              <Slider
                autoplay={true}
                autoplaySpeed={10000}
                pauseOnHover={true}
                dots={true}
                arrows={false}
                infinite={true}
                slidesToShow={1}
                slidesToScroll={1}
                customPaging={function(i) {
                  return <button></button>;
                }}
              >
                {testimonialList.map((list, key) => {
                  return (
                    <div className="item" key={key}>
                      <div
                          className="text"
                          dangerouslySetInnerHTML={{
                            __html: list.text
                          }}
                        ></div>
                      <div className="name">{list.name}</div>
                    </div>
                  );
                })}
              </Slider>
            </div>
          </section>
        </div>
      </React.Fragment>
    );
  }
}

export default HomePage;
